const { REACT_APP_NAME, REACT_APP_VERSION } = process.env;

export const DATABASE_NAME = REACT_APP_NAME;
export const DATABASE_VERSION = Number.parseInt(REACT_APP_VERSION, 10);
export const DATABASE_STORE_NAME = 'store';
